import TrackballControls from 'three-trackballcontrols';
import OrbitControls from 'three-orbitcontrols';
import { threeEngine } from 'Domain/Scene/Engine/ThreeEngine';

/*****************************************************************
 * Control
 * ***************************************************************/

let orbitControl = null, 
    trackballControl = null,
    currentControl = null,
    orthoTrackballDistance = null;

export const Control = {

    setup(camera, rendererDomElement) {
        const EDIT_TRACKBALL_SPEED = 1.5;

        orbitControl = new OrbitControls(camera, rendererDomElement);
        trackballControl = new TrackballControls(camera, rendererDomElement);

        trackballControl.noZoom = false;
        trackballControl.enableZoom = true;
        trackballControl.zoomSpeed = 1.2;
        trackballControl.noPan = false;
        trackballControl.panSpeed = 0.4;
        trackballControl.rotateSpeed = EDIT_TRACKBALL_SPEED;
        trackballControl.staticMoving = true;
        trackballControl.dynamicDampingFactor = 0.25;
        trackballControl.screenSpacePanning = true;
        trackballControl.enabled = false;

        orbitControl.enabled = true;
        orbitControl.enableDamping = true;
        orbitControl.dampingFactor = 0.1;
        orbitControl.enableZoom = true;
        orbitControl.enableRotate = true;
        orbitControl.enablePan = false;
        orbitControl.screenSpacePanning = true;
        orbitControl.rotateSpeed = 0.25;
        orbitControl.minZoom = 0.4;
        orbitControl.maxZoom = 8;

        trackballControl.minDistance = 30;
        trackballControl.maxDistance = 500;
        trackballControl.minZoom = 0.4;
        trackballControl.maxZoom = 8;

        currentControl = orbitControl;
        Control.targetCenter();
    },

    getCurrentRef() {
        return currentControl;
    },

    changeControl() {
        if (orbitControl.enabled) {
            currentControl = trackballControl;
            trackballControl.enabled = true;
            orbitControl.enabled = false;

            const cam = trackballControl.object;
            if (cam?.isOrthographicCamera) {
                orthoTrackballDistance = cam.position.distanceTo(trackballControl.target);
            }
        }
        else {
            currentControl = orbitControl;
            trackballControl.enabled = false;
            orbitControl.enabled = true;
            orthoTrackballDistance = null;
        }
        Control.targetCenter();
    },

    update() {
        if (!currentControl) return;

        if (this._lastCamera !== currentControl.object) {
            this._lastCamera = currentControl.object;
            orthoTrackballDistance = null;
        }

        currentControl.update();

        const cam = currentControl.object;
        if (currentControl === trackballControl && cam?.isOrthographicCamera) {
            if (!orthoTrackballDistance) {
                orthoTrackballDistance = cam.position.distanceTo(trackballControl.target);
                return;
            }

            const target = trackballControl.target;
            const toCam = cam.position.clone().sub(target);
            const currentDistance = toCam.length();

            if (currentDistance > 0 && Math.abs(currentDistance - orthoTrackballDistance) > 1e-6) {
                const zoomFactor = orthoTrackballDistance / currentDistance;
                const minZoom = trackballControl.minZoom ?? 0.1;
                const maxZoom = trackballControl.maxZoom ?? 10;

                cam.zoom = Math.min(maxZoom, Math.max(minZoom, cam.zoom * zoomFactor));
                cam.updateProjectionMatrix();

                toCam.setLength(orthoTrackballDistance);
                cam.position.copy(target).add(toCam);
            }
        }
    },

    targetCenter() {
        currentControl.target.copy(threeEngine.getCenter());
    },

    setOrientationZoom(isPortrait) {
        const camera = currentControl ? currentControl.object : threeEngine.getCamera('main')
        if (!camera) return

        if (isPortrait) {
            orbitControl.minZoom = 0.15
            if (trackballControl) trackballControl.minZoom = 0.15
            camera.zoom = 0.4
        } else {
            orbitControl.minZoom = 0.4
            orbitControl.maxZoom = 8
            if (trackballControl) {
                trackballControl.minZoom = 0.4
                trackballControl.maxZoom = 8
            }
            camera.zoom = 1
        }
        camera.updateProjectionMatrix()
    },

    dispose() {
        if (orbitControl) {
            orbitControl.dispose();
            orbitControl = null;
        }
        if (trackballControl) {
            trackballControl.dispose();
            trackballControl = null;
        }
        currentControl = null;
        orthoTrackballDistance = null;
    }
}
